module.exports = __webpack_public_path__ + "files/ee9a4983324274156f196082d08d2ca4.svg";